import { ArrowRight, MessageCircle, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { siteConfig, waLink } from "@/lib/siteConfig";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 pb-16 md:pb-24 overflow-hidden bg-[#2C2621]"
    >
      {/* Soft pattern background */}
      <div className="absolute inset-0 -z-10 opacity-30">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 30%, rgba(201,122,78,0.25), transparent 40%), radial-gradient(circle at 80% 70%, rgba(140,94,53,0.25), transparent 45%)",
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 fade-up">
          <span
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/15 text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#E8B796] mb-6"
          >
            <Sparkles className="w-3.5 h-3.5" />
            Jasa Bordir Komputer Profesional
          </span>

          <h1
            data-testid="hero-headline"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-bold text-white"
          >
            Hasil Presisi, Detail Rapi.
            <br />
            <span className="text-[#E8B796]">Wujudkan Karya Terbaik Anda.</span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 md:mt-8 font-body text-base md:text-lg leading-relaxed text-[#EFEBE1]/90 max-w-2xl"
          >
            Bordir logo, seragam, kemeja, kaos, topi, hingga handuk dengan kualitas
            mesin komputer otomatis.{" "}
            <span className="font-semibold text-white">TANPA MINIMAL ORDER</span>{" "}
            — kami terima pesanan satuan maupun partai besar dengan hasil yang
            konsisten.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <Button
              asChild
              size="lg"
              data-testid="hero-cta-whatsapp"
              className="rounded-full bg-[#C97A4E] hover:bg-[#B86A3F] text-white font-medium px-7 py-6 text-base shadow-lg shadow-black/30 transition-all duration-300 hover:-translate-y-0.5"
            >
              <a href={waLink()} target="_blank" rel="noopener noreferrer">
                <MessageCircle className="w-5 h-5 mr-2" />
                Konsultasi via WhatsApp
              </a>
            </Button>
            <Button
              asChild
              variant="ghost"
              size="lg"
              data-testid="hero-cta-services"
              className="rounded-full text-white hover:text-white hover:bg-white/10 font-medium px-6 py-6 text-base"
            >
              <a href="#layanan">
                Lihat Layanan
                <ArrowRight className="w-4 h-4 ml-2" />
              </a>
            </Button>
          </div>

          <div className="mt-12 flex flex-wrap gap-6 md:gap-10 text-[#EFEBE1]/80">
            <div data-testid="hero-stat-machines">
              <div className="font-heading text-3xl font-bold text-white">19</div>
              <div className="text-xs uppercase tracking-widest mt-1">
                Kepala Mesin
              </div>
            </div>
            <div className="w-px bg-white/20" />
            <div data-testid="hero-stat-flexibility">
              <div className="font-heading text-3xl font-bold text-white">1 pcs</div>
              <div className="text-xs uppercase tracking-widest mt-1">
                Minimal Order
              </div>
            </div>
            <div className="w-px bg-white/20" />
            <div data-testid="hero-stat-coverage">
              <div className="font-heading text-3xl font-bold text-white">34</div>
              <div className="text-xs uppercase tracking-widest mt-1">
                Provinsi Dilayani
              </div>
            </div>
          </div>
        </div>

        {/* Right image collage */}
        <div className="lg:col-span-5 relative hidden md:block">
          <div className="relative h-[460px] lg:h-[520px]">
            <div className="absolute top-0 right-0 w-[78%] h-[58%] rounded-2xl overflow-hidden shadow-2xl shadow-black/40 ring-1 ring-white/10 rotate-2">
              <img
                src={siteConfig.images.hero}
                alt="Bordir presisi pada kemeja"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.parentElement.style.background =
                    "linear-gradient(135deg,#8C5E35,#C97A4E)";
                }}
              />
            </div>
            <div className="absolute bottom-0 left-0 w-[72%] h-[55%] rounded-2xl overflow-hidden shadow-2xl shadow-black/40 ring-1 ring-white/10 -rotate-3">
              <img
                src={siteConfig.images.heroSecondary}
                alt="Mesin bordir komputer industri"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.parentElement.style.background =
                    "linear-gradient(135deg,#4A3B2F,#8C5E35)";
                }}
              />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-3 right-2 bg-[#F9F6F0] text-[#2C2621] rounded-xl px-4 py-3 shadow-2xl shadow-black/30 max-w-[200px]">
              <div className="text-xs uppercase tracking-widest text-[#8C5E35] font-semibold">
                Standar Komputer
              </div>
              <div className="font-heading text-sm font-semibold leading-tight mt-1">
                Setiap tusukan presisi 0,1mm
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
